import { ToastService } from '@/services/toast-service'
import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser'

const rawScopes = import.meta.env.VITE_APP_MSAL_ACQUIRE_ACCESS_TOKEN_SCOPES || 'User.Read'
const scopes = rawScopes
  .split(',')
  .map((s: string) => s.trim())
  .filter(Boolean)

const authority = import.meta.env.VITE_APP_MSAL_AUTHORITY || ''
const isB2cAuthority = authority.includes('b2clogin.com')

const showScopeMisconfigToast = (details?: string) => {
  ToastService.storeToastMessageJson({
    iconClass: 'warning',
    title: 'Authentication configuration issue',
    message:
      `B2C rejected the API scope(s): ${rawScopes}. ` +
      'Update VITE_APP_MSAL_ACQUIRE_ACCESS_TOKEN_SCOPES to a scope exposed by your B2C API app registration ' +
      '(commonly api://<api-client-id>/<scope> or https://<tenant>.onmicrosoft.com/<app-id-uri>/<scope>). ' +
      (details ? `Details: ${details}` : ''),
    duration: 8000,
    position: 'top-right',
  })
}

export const acquireAccessToken = async (instance: PublicClientApplication) => {
  // Ensure the instance is initialized
  if (!instance.getAllAccounts().length) {
    // log a warning if no accounts are found
    console.warn('[acquireAccessToken] No accounts found. Prompting user to log in interactively.')

    // prompt the user to log in interactively if no accounts are found
    await instance.loginRedirect({
      scopes,
    })
  }

  try {
    return await instance.acquireTokenSilent({
      scopes,
    })
  } catch (error) {
    // Common B2C misconfiguration: requesting an API scope that is not defined in the B2C tenant.
    const errorString = String((error as any)?.message || (error as any)?.errorMessage || error)
    if (isB2cAuthority && errorString.includes('AADB2C90117')) {
      showScopeMisconfigToast(errorString)
      throw error
    }

    if (error instanceof InteractionRequiredAuthError) {
      // use vuestic toast to show that user may need to re-login again
      ToastService.storeToastMessageJson({
        iconClass: 'warning',
        message: 'You may need to re-login again',
        duration: 5000,
        position: 'top-right',
        title: 'Warning',
        // Add any other toast options you want
      })

      // Prompt the user to log in interactively
      return await instance.acquireTokenPopup({
        scopes,
      })
    } else {
      // Handle other errors
      throw error
    }
  }
}
